import { getCurrentFinancialYear } from "../../../utils/commonFunctions";

let year = getCurrentFinancialYear().split("-");

export let dummyData = [
  {
    month: "Apr",
    year: year[0],
    total_amount: 0,
  },
  {
    month: "May",
    year: year[0],
    total_amount: 0,
  },
  {
    month: "Jun",
    year: year[0],
    total_amount: 0,
  },
  {
    month: "Jul",
    year: year[0],
    total_amount: 0,
  },
  {
    month: "Aug",
    year: year[0],
    total_amount: 0,
  },
  {
    month: "Sep",
    year: year[0],
    total_amount: 0,
  },
  {
    month: "Oct",
    year: year[0],
    total_amount: 0,
  },
  {
    month: "Nov",
    year: year[0],
    total_amount: 0,
  },
  {
    month: "Dec",
    year: year[0],
    total_amount: 0,
  },
  {
    month: "Jan",
    year: year[1],
    total_amount: 0,
  },
  {
    month: "Feb",
    year: year[1],
    total_amount: 0,
  },
  {
    month: "Mar",
    year: year[1],
    total_amount: 0,
  },
];
